<template>
  <div class="dataTables_filter text-md-right">
    <!-- Additional buttons before search -->
    <slot name="before-search"></slot>
    
    <label class="d-inline-flex align-items-center">
      Search:
      <b-form-input
        :value="value"
        type="search"
        placeholder="Search..."
        class="form-control form-control-sm ml-2"
        @input="handleInput"
        @keyup.enter="handleSearch"
      ></b-form-input>
    </label>
    <button
      class="ml-1 btn btn-primary btn-sm"
      @click="handleSearch"
    >
      <i class="uil uil-search-alt"></i>
    </button>
    
    <!-- Additional buttons after search -->
    <slot name="after-search"></slot>
  </div>
</template>

<script>
export default {
  name: 'SearchInput',
  props: {
    value: {
      type: String,
      default: ''
    }
  },
  emits: ['input', 'search'],
  methods: {
    handleInput(value) {
      // Emit the input event to update the v-model
      this.$emit('input', value)
      
      // If the input is cleared (X button clicked), automatically trigger search reset
      if (value === '') {
        this.handleSearch()
      }
    },
    handleSearch() {
      this.$emit('search')
    }
  }
}
</script>
